import React from "react";
import styles from "./styles.module.scss";

const RecordButton = ({
  row,
  col,
  disabled,
  recorded,
  onRecord,
}: {
  row: number;
  col: number;
  disabled: boolean;
  recorded: boolean; // true if the cell is already recorded
  onRecord?: (row: number, col: number) => void;
}) => {
  return (
    <div
      role="button"
      tabIndex={disabled || recorded ? -1 : 0}
      className={styles.recordButton}
      style={{
        ...(disabled || recorded
          ? { opacity: recorded ? 0 : 0.5, pointerEvents: "none" }
          : {}),
      }}
      id={row + "_" + col}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onRecord?.(row, col);
        }
      }}
      onClick={() => {
        onRecord?.(row, col);
      }}
    >
      <div className={styles.button}>Record</div>
    </div>
  );
};

export default RecordButton;
